import type { SVGProps } from 'react';

const SvgEncrypted = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.63674 11.3943H8.35842C9.01272 11.3943 9.33498 11.072 9.33498 10.364V6.71654C9.33498 6.07689 9.06643 5.74486 8.52932 5.69115V4.48509C8.52932 2.62962 7.29397 1.73607 5.99514 1.73607C4.70119 1.73607 3.46584 2.62962 3.46584 4.48509V5.71068C2.96291 5.7888 2.66018 6.11107 2.66018 6.71654V10.364C2.66018 11.072 2.98244 11.3943 3.63674 11.3943ZM4.39358 4.39232C4.39358 3.24486 5.12112 2.62474 5.99514 2.62474C6.86916 2.62474 7.60158 3.24486 7.60158 4.39232V5.68626L4.39358 5.69115V4.39232Z"
      fill="white"
    />
  </svg>
);

export default SvgEncrypted;
